import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class RealArea {
  /* 实占面积列表 */
  static getRealAreaList(options) {
    let url = `/oa/api/use/area/import/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 场租重算列表 */
  static getRentRecalculationList() {
    const url = `/oa/api/bill/cal/log/of/rent`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 实占面积导入 */
  static postUploadRealAreaExcel(data) {
    const url = "/oa/api/upload/use/area";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 场租重算执行按钮 */
  static postCarryOut(id) {
    let url = `/oa/api/bill/handle/bill/for/rent/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出实占面积账单 */
  static getExportRealAreaExcel(data) {
    let url = `/oa/api/download/project/use/area?`;
    url += handleGetRequestParams(data)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default RealArea